<template>
  <v-container>
    <v-row class="my-4">
      <v-col cols="6">
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr
                style="height: 20"
                v-for="item in stringValues"
                :key="item.name"
              >
                <td style="font-weight: 700">{{ item.name }}:</td>
                <td v-if="item.value === 'No'">
                  <v-icon color="red">mdi-close-circle</v-icon>
                </td>
                <td v-else-if="item.value === 'Yes'">
                  <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                </td>
                <td v-else>{{ item.value }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col cols="6">
        <v-simple-table dense v-if="simpleArrays.length > 0">
          <template v-slot:default>
            <tbody>
              <tr
                style="height: 20"
                v-for="item in simpleArrays"
                :key="item.name"
              >
                <td style="font-weight: 700; width: 30%">{{ item.name }}:</td>
                <td>
                  <span v-for="(word, i) in item.value" :key="i">
                    {{ word }}
                    <span v-if="i !== item.value.length - 1">, </span>
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider v-if="simpleArrays.length > 0"></v-divider>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr
                style="height: 20"
                v-for="item in simpleObjects"
                :key="item.name"
              >
                <td style="font-weight: 700">{{ item.name }}:</td>
                <td>
                  <span
                    v-for="[key, value] of Object.entries(item.value)"
                    :key="key"
                  >
                    {{ key }}: {{ value }},
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <div v-if="product.Measurement !== undefined">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td style="font-weight: 700; width: 30%">Measurements:</td>
                  <td>
                    <ProductObjects
                      :items="product.Measurement"
                    ></ProductObjects>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider></v-divider>
        </div>
        <div v-if="product.Size !== undefined">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td style="font-weight: 700; width: 30%">Sizes:</td>
                  <td>
                    <ProductObjects :items="product.Size"></ProductObjects>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider></v-divider>
        </div>
        <div v-if="product.Other !== undefined">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td style="font-weight: 700; width: 30%">Other:</td>
                  <td>
                    <ProductObjects :items="product.Other"></ProductObjects>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider></v-divider>
        </div>
        <div v-if="product.Composition !== undefined">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td style="font-weight: 700; width: 30%">Compositions:</td>
                  <td>
                    <Compositions
                      :compositions="product.Composition"
                    ></Compositions>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider></v-divider>
        </div>
      </v-col>
    </v-row>
    <v-card flat width="100%" v-if="this.product.Photos">
      <v-row class="mt-0 pt-0 mb-4">
        <v-col v-for="photo in this.product.Photos" :key="photo" cols="1">
          <expandable-image :src="photo"> </expandable-image>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import ProductObjects from "../Descriptions/ProductObjects.vue";
import Compositions from "../Descriptions/Compositions.vue";

export default {
  name: "ProductInfo",
  components: {
    ProductObjects,
    Compositions,
  },
  props: {
    product: Object,
  },
  computed: {
    sizes() {
      return this.product.Size;
    },
    stringValues() {
      let values = [];
      let excludeKeys = [
        "ExportState",
        "Location",
        "idPath",
        "Category",
        "isASet",
        "SKU",
        "descriptionType",
        "AttentionMessage",
        "Type",
        "stock",
        "add",
      ];
      for (let [key, value] of Object.entries(this.product).sort()) {
        if (
          typeof value === "string" ||
          typeof value === "boolean" ||
          typeof value === "number"
        ) {
          if (!excludeKeys.includes(key)) {
            if (key == "StyleCode") {
              key = "Style code";
            } else if (key == "SubBrand") {
              key = "Sub-brand";
            } else if (key == "StyleName") {
              key = "Style name";
            } else if (key == "ManufacturerColor") {
              key = "Manufacturer color";
            } else if (key == "WholesalePrice") {
              key = "Wholesale price";
            } else if (key == "WholesalePrice") {
              key = "Wholesale price";
            } else if (key == "RealColor") {
              key = "Real color";
            } else if (key == "SetOf") {
              key = "Set of";
            } else if (key == "GarmentCare") {
              key = "Garment care";
            } else if (typeof value == "boolean") {
              if (value == true) {
                value = "Yes";
              } else {
                value = "No";
              }
            }
            values.push({ name: key, value: value });
          }
        }
      }
      return values;
    },
    simpleObjects() {
      let values = [];
      let excludeKeys = [
        "Photos",
        "Composition",
        "Size",
        "Measurement",
        "Other",
      ];
      for (let [key, value] of Object.entries(this.product)) {
        if (
          typeof value === "object" &&
          !Array.isArray(value) &&
          !excludeKeys.includes(key)
        ) {
          values.push({ name: key, value: value });
        }
      }

      return values;
    },
    simpleArrays() {
      let values = [];
      let excludeKeys = ["Photos", "LinnworksPhotos", "actions"];

      for (let [key, value] of Object.entries(this.product).sort()) {
        if (!excludeKeys.includes(key)) {
          if (key == "ConditionDescription") {
            key = "Condition Description";
          }
          if (Array.isArray(value)) {
            values.push({ name: key, value: value });
          }
        }
      }
      return values;
    },
  },
};
</script>
